export default __webpack_public_path__ + "static/panel-anatomy-light-b597ddf9519c49abbae0017ae903c4531e8ee4f0173b3f981eb63a5e4d2214a9.png";